export class GymReportDownload {
  radius3km: number;
  radius5km: number;
  radius20km: number;

  constructor(public id: string | null) {}
}
